export const walkthroughWithData = {
  chartData: {
    schema: {
      name: 'pnl',
      title: 'PnL',
      properties: [
        {
          name: 'date',
          title: 'Date',
          type: 'date',
        },
        {
          name: 'pnl',
          title: 'PnL',
          type: 'amount',
        },
      ],
    },
    records: [
      {
        color: '#59cdd5',
        name: 'PnL',
        data: [
          [1357689600000, 9764],
          [1357776000000, 30488],
          [1357862400000, 28385],
          [1358121600000, 17740],
          [1358208000000, 25582],
          [1358294400000, 28055],
          [1358380800000, 29545],
          [1358467200000, 5124],
          [1358812800000, 18550],
          [1358899200000, 28686],
          [1358985600000, 18120],
          [1359072000000, -8985],
          [1359331200000, 25546],
          [1359417600000, 48657],
          [1359504000000, 27468],
          [1359590400000, 47662],
          [1359676800000, 47979],
          [1359936000000, 39693],
          [1360022400000, 61079],
          [1360108800000, 86199],
          [1360195200000, 69521],
          [1360281600000, 52408],
          [1360540800000, 50183],
          [1360627200000, 65007],
          [1360713600000, 63170],
          [1360800000000, 53081],
          [1360886400000, 34260],
          [1361232000000, 23097],
          [1361318400000, 6142],
          [1361404800000, 12204],
          [1361491200000, 3055],
          [1361750400000, 11554],
          [1361836800000, 45],
          [1361923200000, 16543],
          [1362009600000, 3496],
          [1362096000000, -26973],
          [1362355200000, -88650],
          [1362441600000, -88029],
          [1362528000000, -14045],
          [1362614400000, 35114],
          [1362700800000, 66560],
          [1362960000000, 62609],
          [1363046400000, 92734],
          [1363132800000, 57343],
          [1363219200000, 36965],
          [1363305600000, 18140],
          [1363564800000, 9880],
          [1363651200000, -19057],
          [1363737600000, -12120],
          [1363824000000, -10567],
          [1363910400000, -11914],
          [1364169600000, -37969],
          [1364256000000, -34219],
          [1364342400000, -37427],
          [1364428800000, -50272],
          [1364770800000, -74318],
          [1364857200000, -95172],
          [1364943600000, -99614],
          [1365030000000, -85459],
          [1365116400000, -64476],
          [1365375600000, -63015],
          [1365462000000, -31384],
          [1365548400000, 5734],
          [1365634800000, -18986],
          [1365721200000, -49773],
          [1365980400000, -97905],
          [1366066800000, -117036],
          [1366153200000, -169210],
          [1366239600000, -152133],
          [1366326000000, -167209],
          [1366585200000, -169762],
          [1366671600000, -166097],
          [1366758000000, -85181],
          [1366844400000, -35161],
          [1366930800000, -30351],
          [1367190000000, -21227],
          [1367276400000, -20974],
          [1367362800000, -1537],
          [1367449200000, -8915],
          [1367535600000, -1224],
          [1367794800000, -3597],
          [1367881200000, -18740],
          [1367967600000, -9271],
          [1368054000000, 8675],
          [1368140400000, 53705],
          [1368399600000, 77849],
          [1368486000000, 65711],
          [1368572400000, 44813],
          [1368658800000, 64395],
          [1368745200000, 15806],
          [1369004400000, 74899],
          [1369090800000, 67816],
          [1369177200000, 112932],
          [1369263600000, 132645],
          [1369350000000, 117509],
          [1369695600000, 76681],
          [1369782000000, 72951],
          [1369868400000, 62093],
          [1369954800000, 47378],
          [1370214000000, -2733],
          [1370300400000, 16555],
          [1370386800000, 14343],
          [1370473200000, 43141],
          [1370559600000, 44102],
          [1370818800000, -6071],
          [1370905200000, -27139],
          [1370991600000, -57562],
          [1371078000000, -757],
          [1371164400000, -2727],
          [1371423600000, -22606],
          [1371510000000, -43708],
          [1371596400000, -81332],
          [1371682800000, -114280],
          [1371769200000, -118272],
          [1372028400000, -167511],
          [1372114800000, -128848],
          [1372201200000, -137539],
          [1372287600000, -113936],
          [1372374000000, -98750],
          [1372633200000, -67394],
          [1372719600000, -80732],
          [1372806000000, -64939],
          [1372978800000, -100843],
          [1373238000000, -90796],
          [1373324400000, -60295],
          [1373410800000, -51845],
          [1373497200000, 53257],
          [1373583600000, 46150],
          [1373842800000, 60274],
          [1373929200000, 87048],
          [1374015600000, 99257],
          [1374102000000, 102606],
          [1374188400000, 103956],
          [1374447600000, 115822],
          [1374534000000, 121805],
          [1374620400000, 114124],
          [1374706800000, 114548],
          [1374793200000, 122727],
          [1375052400000, 126461],
          [1375138800000, 150728],
          [1375225200000, 173905],
          [1375311600000, 173792],
          [1375398000000, 169850],
          [1375657200000, 176560],
          [1375743600000, 191800],
          [1375830000000, 193554],
          [1375916400000, 225212],
          [1376002800000, 232480],
          [1376262000000, 220324],
          [1376348400000, 198999],
          [1376434800000, 202023],
          [1376521200000, 208473],
          [1376607600000, 186286],
          [1376866800000, 179859],
          [1376953200000, 199813],
          [1377039600000, 204248],
          [1377126000000, 185074],
          [1377212400000, 177394],
          [1377471600000, 127375],
          [1377558000000, 174555],
          [1377644400000, 165482],
          [1377730800000, 161749],
          [1377817200000, 163936],
          [1378162800000, 146519],
          [1378249200000, 135968],
          [1378335600000, 99691],
          [1378422000000, 125273],
          [1378681200000, 118783],
          [1378767600000, 75542],
          [1378854000000, 101283],
          [1378940400000, 116532],
          [1379026800000, 132065],
          [1379286000000, 98299],
          [1379372400000, 111506],
          [1379458800000, 119834],
          [1379545200000, 119883],
          [1379631600000, 101649],
          [1379890800000, 88089],
          [1379977200000, 103689],
          [1380063600000, 168568],
          [1380150000000, 154027],
          [1380236400000, 148587],
          [1380495600000, 115677],
          [1380582000000, 101970],
          [1380668400000, 110068],
          [1380754800000, 107885],
          [1380841200000, 101653],
          [1381100400000, 127954],
          [1381186800000, 187375],
          [1381273200000, 223419],
          [1381359600000, 216375],
          [1381446000000, 222658],
          [1381705200000, 214584],
          [1381791600000, 198347],
          [1381878000000, 203482],
          [1381964400000, 231875],
          [1382050800000, 190653],
          [1382310000000, 185280],
          [1382396400000, 210778],
          [1382482800000, 222669],
          [1382569200000, 235326],
          [1382655600000, 217505],
          [1382918400000, 203604],
          [1383004800000, 248991],
          [1383091200000, 209326],
          [1383177600000, 235540],
          [1383264000000, 267371],
          [1383523200000, 291265],
          [1383609600000, 274451],
          [1383696000000, 254846],
          [1383782400000, 261335],
          [1383868800000, 248045],
          [1384128000000, 237108],
          [1384214400000, 223382],
          [1384300800000, 226503],
          [1384387200000, 244950],
          [1384473600000, 252003],
          [1384732800000, 243155],
          [1384819200000, 252453],
          [1384905600000, 254668],
          [1384992000000, 268541],
          [1385078400000, 243911],
          [1385337600000, 220946],
          [1385424000000, 221777],
          [1385510400000, 204707],
          [1385683200000, 220894],
          [1385942400000, 233970],
          [1386028800000, 256707],
          [1386115200000, 289978],
          [1386201600000, 278088],
          [1386288000000, 288382],
          [1386547200000, 299654],
          [1386633600000, 317476],
          [1386720000000, 321716],
          [1386806400000, 330947],
          [1386892800000, 334598],
          [1387152000000, 329921],
          [1387238400000, 321270],
          [1387324800000, 317314],
          [1387411200000, 329011],
          [1387497600000, 328030],
          [1387756800000, 321637],
          [1387843200000, 334626],
          [1388016000000, 334606],
          [1388102400000, 342668],
          [1388361600000, 338981],
          [1388448000000, 332471],
          [1388620800000, 388333],
          [1388707200000, 420176],
          [1388966400000, 420702],
          [1389052800000, 450311],
          [1389139200000, 420863],
          [1389225600000, 378653],
          [1389312000000, 334336],
          [1389571200000, 327039],
          [1389657600000, 298210],
          [1389744000000, 306474],
          [1389830400000, 277236],
          [1389916800000, 267434],
          [1390262400000, 235717],
          [1390348800000, 249268],
          [1390435200000, 213008],
          [1390521600000, 220418],
          [1390780800000, 274170],
          [1390867200000, 267460],
          [1390953600000, 246676],
          [1391040000000, 232406],
          [1391126400000, 204702],
          [1391385600000, 186746],
          [1391472000000, 173742],
          [1391558400000, 187921],
          [1391644800000, 210340],
          [1391731200000, 212665],
          [1391990400000, 219980],
          [1392076800000, 231646],
          [1392163200000, 228087],
          [1392249600000, 265368],
          [1392336000000, 265874],
          [1392681600000, 272246],
          [1392768000000, 283681],
          [1392854400000, 265330],
          [1392940800000, 287457],
          [1393200000000, 309624],
          [1393286400000, 327186],
          [1393372800000, 340288],
          [1393459200000, 355291],
          [1393545600000, 375077],
          [1393804800000, 385886],
          [1393891200000, 361462],
          [1393977600000, 386835],
          [1394064000000, 397273],
          [1394150400000, 363727],
          [1394409600000, 362700],
          [1394496000000, 373629],
          [1394582400000, 392780],
          [1394668800000, 374866],
          [1394755200000, 398438],
          [1395014400000, 408598],
          [1395100800000, 454574],
          [1395187200000, 481910],
          [1395273600000, 445800],
          [1395360000000, 409667],
          [1395619200000, 379679],
          [1395705600000, 404278],
          [1395792000000, 360820],
          [1395878400000, 361385],
          [1395964800000, 321730],
          [1396220400000, 375881],
          [1396306800000, 478951],
          [1396393200000, 465993],
          [1396479600000, 359794],
          [1396566000000, 220457],
          [1396825200000, 194337],
          [1396911600000, 225573],
          [1396998000000, 326570],
          [1397084400000, 169798],
          [1397170800000, 104662],
          [1397430000000, 62491],
          [1397516400000, 75049],
          [1397602800000, 132451],
          [1397689200000, 176256],
          [1398034800000, 205388],
          [1398121200000, 326470],
          [1398207600000, 280780],
          [1398294000000, 281772],
          [1398380400000, 278731],
          [1398639600000, 260469],
          [1398726000000, 296170],
          [1398812400000, 301973],
          [1398898800000, 327984],
          [1398985200000, 329721],
          [1399244400000, 299650],
          [1399330800000, 229864],
          [1399417200000, 201594],
          [1399503600000, 130270],
          [1399590000000, 188153],
          [1399849200000, 264804],
          [1399935600000, 254062],
          [1400022000000, 249835],
          [1400108400000, 215322],
          [1400194800000, 207779],
          [1400454000000, 238969],
          [1400540400000, 219481],
          [1400626800000, 225101],
          [1400713200000, 259314],
          [1400799600000, 270989],
          [1401145200000, 276610],
          [1401231600000, 274114],
          [1401318000000, 280913],
          [1401404400000, 311301],
          [1401663600000, 306475],
          [1401750000000, 303959],
          [1401836400000, 302759],
          [1401922800000, 380216],
          [1402009200000, 428555],
          [1402268400000, 507223],
          [1402354800000, 531471],
          [1402441200000, 568448],
          [1402527600000, 585021],
          [1402614000000, 592206],
          [1402873200000, 558522],
          [1402959600000, 549712],
          [1403046000000, 544670],
          [1403132400000, 554108],
          [1403218800000, 554018],
          [1403478000000, 523990],
          [1403564400000, 566150],
          [1403650800000, 573605],
          [1403737200000, 555522],
          [1403823600000, 549108],
          [1404082800000, 551551],
          [1404169200000, 582711],
          [1404255600000, 603034],
          [1404342000000, 612157],
          [1404687600000, 594009],
          [1404774000000, 596393],
          [1404860400000, 586820],
          [1404946800000, 577330],
          [1405033200000, 570843],
          [1405292400000, 587782],
          [1405378800000, 561609],
          [1405465200000, 552745],
          [1405551600000, 522672],
          [1405638000000, 547755],
          [1405897200000, 516221],
          [1405983600000, 523513],
          [1406070000000, 559628],
          [1406156400000, 572823],
          [1406242800000, 564065],
          [1406502000000, 539245],
          [1406588400000, 565941],
          [1406674800000, 575502],
          [1406761200000, 574711],
          [1406847600000, 601657],
          [1407106800000, 595110],
          [1407193200000, 562993],
          [1407279600000, 564998],
          [1407366000000, 586538],
          [1407452400000, 601020],
          [1407711600000, 574024],
          [1407798000000, 581345],
          [1407884400000, 601512],
          [1407970800000, 596670],
          [1408057200000, 596681],
          [1408316400000, 595308],
          [1408402800000, 606885],
          [1408489200000, 590194],
          [1408575600000, 596299],
          [1408662000000, 613969],
          [1408921200000, 608945],
          [1409007600000, 658599],
          [1409094000000, 644385],
          [1409180400000, 627965],
          [1409266800000, 626320],
          [1409612400000, 625453],
          [1409698800000, 610416],
          [1409785200000, 627931],
          [1409871600000, 624225],
          [1410130800000, 643168],
          [1410217200000, 624457],
          [1410303600000, 648016],
          [1410390000000, 665520],
          [1410476400000, 638022],
          [1410735600000, 688186],
          [1410822000000, 716287],
          [1410908400000, 678933],
          [1410994800000, 646247],
          [1411081200000, 630733],
          [1411340400000, 599240],
          [1411426800000, 595076],
          [1411513200000, 571070],
          [1411599600000, 571135],
          [1411686000000, 556610],
          [1411945200000, 527556],
          [1412031600000, 522319],
          [1412118000000, 558701],
          [1412204400000, 588657],
          [1412290800000, 537196],
          [1412550000000, 564306],
          [1412636400000, 533546],
          [1412722800000, 493365],
          [1412809200000, 372801],
          [1412895600000, 254408],
          [1413154800000, 82003],
          [1413241200000, 10364],
          [1413327600000, 164884],
          [1413414000000, 362025],
          [1413500400000, 494932],
          [1413759600000, 493955],
          [1413846000000, 573868],
          [1413932400000, 605542],
          [1414018800000, 592684],
          [1414105200000, 591365],
          [1414368000000, 524442],
          [1414454400000, 619281],
          [1414540800000, 596971],
          [1414627200000, 561486],
          [1414713600000, 586397],
          [1414972800000, 561561],
          [1415059200000, 448695],
          [1415145600000, 430399],
          [1415232000000, 487001],
          [1415318400000, 628786],
          [1415577600000, 588179],
          [1415664000000, 619554],
          [1415750400000, 617362],
          [1415836800000, 587305],
          [1415923200000, 630474],
          [1416182400000, 612751],
          [1416268800000, 637588],
          [1416355200000, 632363],
          [1416441600000, 661898],
          [1416528000000, 653250],
          [1416787200000, 680054],
          [1416873600000, 665707],
          [1416960000000, 682289],
          [1417132800000, 647418],
          [1417392000000, 605826],
          [1417478400000, 563952],
          [1417564800000, 614745],
          [1417651200000, 510931],
          [1417737600000, 474538],
          [1417996800000, 231297],
          [1418083200000, 340172],
          [1418169600000, 220713],
          [1418256000000, 171567],
          [1418342400000, 160115],
          [1418601600000, 133404],
          [1418688000000, 173493],
          [1418774400000, 263542],
          [1418860800000, 336161],
          [1418947200000, 396029],
          [1419206400000, 392209],
          [1419292800000, 396053],
          [1419379200000, 442929],
          [1419552000000, 487325],
          [1419811200000, 462412],
          [1419897600000, 489857],
          [1419984000000, 545025],
          [1420156800000, 607815],
          [1420416000000, 588160],
          [1420502400000, 577027],
          [1420588800000, 544831],
          [1420675200000, 596223],
          [1420761600000, 531016],
          [1421020800000, 399983],
          [1421107200000, 430734],
          [1421193600000, 392426],
          [1421280000000, 353710],
          [1421366400000, 375322],
          [1421712000000, 349173],
          [1421798400000, 397383],
          [1421884800000, 465099],
          [1421971200000, 459169],
          [1422230400000, 479908],
          [1422316800000, 460905],
          [1422403200000, 425523],
          [1422489600000, 437933],
          [1422576000000, 401687],
          [1422835200000, 440737],
          [1422921600000, 487566],
          [1423008000000, 515909],
          [1423094400000, 544658],
          [1423180800000, 520140],
          [1423440000000, 518065],
          [1423526400000, 588104],
          [1423612800000, 597359],
          [1423699200000, 577038],
          [1423785600000, 566127],
          [1424131200000, 570464],
          [1424217600000, 618807],
          [1424304000000, 591945],
          [1424390400000, 558183],
          [1424649600000, 563128],
          [1424736000000, 574493],
          [1424822400000, 582424],
          [1424908800000, 550628],
          [1424995200000, 578154],
          [1425254400000, 542420],
          [1425340800000, 558004],
          [1425427200000, 560746],
          [1425513600000, 553337],
          [1425600000000, 551280],
          [1425859200000, 532130],
          [1425945600000, 513201],
          [1426032000000, 513284],
          [1426118400000, 480470],
          [1426204800000, 428974],
          [1426464000000, 420801],
          [1426550400000, 408097],
          [1426636800000, 525790],
          [1426723200000, 453068],
          [1426809600000, 481079],
          [1427068800000, 541395],
          [1427155200000, 580793],
          [1427241600000, 622388],
          [1427328000000, 670698],
          [1427414400000, 706938],
          [1427670000000, 737803],
          [1427756400000, 723576],
          [1427842800000, 717415],
          [1427929200000, 707006],
          [1428274800000, 706882],
          [1428361200000, 726364],
          [1428447600000, 748701],
          [1428534000000, 713831],
          [1428620400000, 728973],
          [1428879600000, 744594],
          [1428966000000, 712029],
          [1429052400000, 660155],
          [1429138800000, 638238],
          [1429225200000, 658528],
          [1429484400000, 680806],
          [1429570800000, 707851],
          [1429657200000, 712618],
          [1429743600000, 693890],
          [1429830000000, 693135],
          [1430089200000, 694596],
          [1430175600000, 717129],
          [1430262000000, 713375],
          [1430348400000, 706571],
          [1430434800000, 741549],
          [1430694000000, 762709],
          [1430780400000, 704842],
          [1430866800000, 753962],
          [1430953200000, 823365],
          [1431039600000, 852636],
          [1431298800000, 861019],
          [1431385200000, 855641],
          [1431471600000, 851685],
          [1431558000000, 851670],
          [1431644400000, 888975],
          [1431903600000, 862198],
          [1431990000000, 821333],
          [1432076400000, 812206],
          [1432162800000, 850645],
          [1432249200000, 833043],
          [1432594800000, 779594],
          [1432681200000, 772834],
          [1432767600000, 774760],
          [1432854000000, 751464],
          [1433113200000, 726535],
          [1433199600000, 790796],
          [1433286000000, 781844],
          [1433372400000, 762772],
          [1433458800000, 713383],
          [1433718000000, 716327],
          [1433804400000, 703837],
          [1433890800000, 670954],
          [1433977200000, 686156],
          [1434063600000, 648841],
          [1434322800000, 642885],
          [1434409200000, 617373],
          [1434495600000, 634120],
          [1434582000000, 630581],
          [1434668400000, 615732],
          [1434927600000, 636905],
          [1435014000000, 677716],
          [1435100400000, 678044],
          [1435186800000, 613052],
          [1435273200000, 583804],
          [1435532400000, 614088],
          [1435618800000, 612581],
          [1435705200000, 563389],
          [1435791600000, 607293],
          [1436137200000, 543917],
          [1436223600000, 553290],
          [1436310000000, 487840],
          [1436396400000, 550347],
          [1436482800000, 543572],
          [1436742000000, 566500],
          [1436828400000, 590904],
          [1436914800000, 515545],
          [1437001200000, 464731],
          [1437087600000, 396117],
          [1437346800000, 266953],
          [1437433200000, 308092],
          [1437519600000, 204993],
          [1437606000000, 218050],
          [1437692400000, 171462],
          [1437951600000, 177846],
          [1438038000000, 217920],
          [1438124400000, 300190],
          [1438210800000, 282816],
          [1438297200000, 266910],
          [1438556400000, 235934],
          [1438642800000, 244148],
          [1438729200000, 223093],
          [1438815600000, 253981],
          [1438902000000, 180700],
          [1439161200000, 315604],
          [1439247600000, 258132],
          [1439334000000, 324163],
          [1439420400000, 267470],
          [1439506800000, 249106],
          [1439766000000, 266961],
          [1439852400000, 234817],
          [1439938800000, 164386],
          [1440025200000, 88957],
          [1440111600000, 103555],
          [1440370800000, 126997],
          [1440457200000, 200263],
          [1440543600000, 249512],
          [1440630000000, 327306],
          [1440716400000, 318157],
          [1440975600000, 336271],
          [1441062000000, 343451],
          [1441148400000, 310541],
          [1441234800000, 327074],
          [1441321200000, 299007],
          [1441666800000, 302746],
          [1441753200000, 313271],
          [1441839600000, 300400],
          [1441926000000, 302312],
          [1442185200000, 290652],
          [1442271600000, 294338],
          [1442358000000, 393207],
          [1442444400000, 367210],
          [1442530800000, 303719],
          [1442790000000, 308007],
          [1442876400000, 288494],
          [1442962800000, 222885],
          [1443049200000, 227775],
          [1443135600000, 196570],
          [1443394800000, 96686],
          [1443481200000, 66695],
          [1443567600000, 157719],
          [1443654000000, 167003],
          [1443740400000, 352115],
          [1443999600000, 402295],
          [1444086000000, 378705],
          [1444172400000, 451376],
          [1444258800000, 392896],
          [1444345200000, 445995],
          [1444604400000, 522117],
          [1444690800000, 499969],
          [1444777200000, 481720],
          [1444863600000, 622085],
          [1444950000000, 637570],
          [1445209200000, 640026],
          [1445295600000, 630455],
          [1445382000000, 593389],
          [1445468400000, 620094],
          [1445554800000, 669433],
          [1445817600000, 594012],
          [1445904000000, 530465],
          [1445990400000, 619462],
          [1446076800000, 611841],
          [1446163200000, 630262],
          [1446422400000, 677632],
          [1446508800000, 770999],
          [1446595200000, 762704],
          [1446681600000, 766359],
          [1446768000000, 752939],
          [1447027200000, 771146],
          [1447113600000, 770719],
          [1447200000000, 825551],
          [1447286400000, 864130],
          [1447372800000, 836008],
          [1447632000000, 858896],
          [1447718400000, 801470],
          [1447804800000, 812815],
          [1447891200000, 797447],
          [1447977600000, 805773],
          [1448236800000, 831604],
          [1448323200000, 895463],
          [1448409600000, 915565],
          [1448582400000, 895084],
          [1448841600000, 920615],
          [1448928000000, 938946],
          [1449014400000, 927807],
          [1449100800000, 961974],
          [1449187200000, 905067],
          [1449446400000, 884203],
          [1449532800000, 862442],
          [1449619200000, 925663],
          [1449705600000, 956467],
          [1449792000000, 884247],
          [1450051200000, 852520],
          [1450137600000, 845148],
          [1450224000000, 827210],
          [1450310400000, 812444],
          [1450396800000, 781397],
          [1450656000000, 803881],
          [1450742400000, 875514],
          [1450828800000, 986467],
          [1450915200000, 981595],
          [1451260800000, 953256],
          [1451347200000, 983249],
          [1451433600000, 974897],
          [1451520000000, 1025107],
          [1451865600000, 1062422],
          [1451952000000, 1025338],
          [1452038400000, 977846],
          [1452124800000, 935517],
          [1452211200000, 911477],
          [1452470400000, 940374],
          [1452556800000, 1008897],
          [1452643200000, 921480],
          [1452729600000, 1023191],
          [1452816000000, 947561],
          [1453161600000, 773738],
          [1453248000000, 794541],
          [1453334400000, 915680],
          [1453420800000, 988098],
          [1453680000000, 893918],
          [1453766400000, 912399],
          [1453852800000, 975282],
          [1453939200000, 949279],
          [1454025600000, 937010],
          [1454284800000, 977325],
          [1454371200000, 929992],
          [1454457600000, 833037],
          [1454544000000, 896625],
          [1454630400000, 756092],
          [1454889600000, 642825],
          [1454976000000, 713097],
          [1455062400000, 762009],
          [1455148800000, 755889],
          [1455235200000, 760072],
          [1455580800000, 850306],
          [1455667200000, 923301],
          [1455753600000, 898145],
          [1455840000000, 846959],
          [1456099200000, 916776],
          [1456185600000, 898805],
          [1456272000000, 888964],
          [1456358400000, 913277],
          [1456444800000, 981301],
          [1456704000000, 971736],
          [1456790400000, 1011216],
          [1456876800000, 1136000],
          [1456963200000, 1144941],
          [1457049600000, 1166825],
          [1457308800000, 1156023],
          [1457395200000, 1270133],
          [1457481600000, 1266953],
          [1457568000000, 1273185],
          [1457654400000, 1260580],
          [1457913600000, 1326240],
          [1458000000000, 1298501],
          [1458086400000, 1229381],
          [1458172800000, 1200909],
          [1458259200000, 1283827],
          [1458518400000, 1310622],
          [1458604800000, 1354653],
          [1458691200000, 1315060],
          [1458777600000, 1300744],
          [1459119600000, 1301810],
          [1459206000000, 1283133],
          [1459292400000, 1302923],
          [1459378800000, 1283103],
          [1459465200000, 1245531],
          [1459724400000, 1211041],
          [1459810800000, 1210836],
          [1459897200000, 1168825],
          [1459983600000, 1134514],
          [1460070000000, 1207273],
          [1460329200000, 1282556],
          [1460415600000, 1334578],
          [1460502000000, 1400902],
          [1460588400000, 1406046],
          [1460674800000, 1413027],
          [1460934000000, 1409612],
          [1461020400000, 1298334],
          [1461106800000, 1261827],
          [1461193200000, 1288303],
          [1461279600000, 1293430],
          [1461538800000, 1323276],
          [1461625200000, 1274801],
          [1461711600000, 1261764],
          [1461798000000, 1304980],
          [1461884400000, 1285477],
          [1462143600000, 1310331],
          [1462230000000, 1331995],
          [1462316400000, 1265308],
          [1462402800000, 1251992],
          [1462489200000, 1212251],
          [1462748400000, 1220475],
          [1462834800000, 1250311],
          [1462921200000, 1219251],
          [1463007600000, 1082968],
          [1463094000000, 1074235],
          [1463353200000, 1105644],
          [1463439600000, 1139071],
          [1463526000000, 1199245],
          [1463612400000, 1184038],
          [1463698800000, 1177334],
          [1463958000000, 1152439],
          [1464044400000, 1157434],
          [1464130800000, 1140300],
          [1464217200000, 1153405],
          [1464303600000, 1139041],
          [1464649200000, 1084789],
          [1464735600000, 1081845],
          [1464822000000, 1049274],
          [1464908400000, 1111400],
          [1465167600000, 1176578],
          [1465254000000, 1205220],
          [1465340400000, 1206909],
          [1465426800000, 1172387],
          [1465513200000, 1164359],
          [1465772400000, 1136301],
          [1465858800000, 1092740],
          [1465945200000, 1106475],
          [1466031600000, 1071273],
          [1466118000000, 1057291],
          [1466377200000, 1114338],
          [1466463600000, 1080874],
          [1466550000000, 1097852],
          [1466636400000, 1135445],
          [1466722800000, 1133415],
          [1466982000000, 1120543],
          [1467068400000, 1107404],
          [1467154800000, 1097882],
          [1467241200000, 1081780],
          [1467327600000, 1109650],
          [1467673200000, 991562],
          [1467759600000, 1006225],
          [1467846000000, 1045226],
          [1467932400000, 1070367],
          [1468191600000, 1100131],
          [1468278000000, 1186662],
          [1468364400000, 1171390],
          [1468450800000, 1144496],
          [1468537200000, 1146892],
          [1468796400000, 1157710],
          [1468882800000, 1126932],
          [1468969200000, 1142301],
          [1469055600000, 1167044],
          [1469142000000, 1158485],
          [1469401200000, 1102559],
          [1469487600000, 1128485],
          [1469574000000, 1106881],
          [1469660400000, 1105336],
          [1469746800000, 1122705],
          [1470006000000, 1045440],
          [1470092400000, 1052225],
          [1470178800000, 1074993],
          [1470265200000, 1044374],
          [1470351600000, 1067345],
          [1470610800000, 1070376],
          [1470697200000, 1041305],
          [1470783600000, 1050209],
          [1470870000000, 986813],
          [1470956400000, 974255],
          [1471215600000, 933533],
          [1471302000000, 907733],
          [1471388400000, 892925],
          [1471474800000, 854186],
          [1471561200000, 841942],
          [1471820400000, 870862],
          [1471906800000, 860204],
          [1471993200000, 840867],
          [1472079600000, 826162],
          [1472166000000, 803014],
          [1472425200000, 795932],
          [1472511600000, 741377],
          [1472598000000, 714402],
          [1472684400000, 746366],
          [1472770800000, 745422],
          [1473116400000, 810149],
          [1473202800000, 818005],
          [1473289200000, 842457],
          [1473375600000, 814686],
          [1473634800000, 832998],
          [1473721200000, 849254],
          [1473807600000, 817457],
          [1473894000000, 777817],
          [1473980400000, 730889],
          [1474239600000, 707465],
          [1474326000000, 664032],
          [1474412400000, 676370],
          [1474498800000, 723629],
          [1474585200000, 723682],
          [1474844400000, 712582],
          [1474930800000, 698235],
          [1475017200000, 756272],
          [1475103600000, 782812],
          [1475190000000, 811320],
          [1475449200000, 838357],
          [1475535600000, 794790],
          [1475622000000, 749711],
          [1475708400000, 728630],
          [1475794800000, 754451],
          [1476054000000, 760108],
          [1476140400000, 775864],
          [1476226800000, 831397],
          [1476313200000, 913236],
          [1476399600000, 886548],
          [1476658800000, 882817],
          [1476745200000, 892163],
          [1476831600000, 889045],
          [1476918000000, 912437],
          [1477004400000, 908396],
          [1477263600000, 895229],
          [1477350000000, 840493],
          [1477436400000, 857753],
          [1477522800000, 823752],
          [1477609200000, 806645],
          [1477872000000, 766845],
          [1477958400000, 783596],
          [1478044800000, 715121],
          [1478131200000, 633820],
          [1478217600000, 672046],
          [1478476800000, 723744],
          [1478563200000, 712452],
          [1478649600000, 687878],
          [1478736000000, 645301],
          [1478822400000, 612470],
          [1479081600000, 566550],
          [1479168000000, 658433],
          [1479254400000, 701413],
          [1479340800000, 677821],
          [1479427200000, 662843],
          [1479686400000, 722578],
          [1479772800000, 698659],
          [1479859200000, 675951],
          [1480032000000, 699305],
          [1480291200000, 686444],
          [1480377600000, 668132],
          [1480464000000, 674592],
          [1480550400000, 601855],
          [1480636800000, 626030],
          [1480896000000, 681512],
          [1480982400000, 681379],
          [1481068800000, 605454],
          [1481155200000, 604693],
          [1481241600000, 620009],
          [1481500800000, 622986],
          [1481587200000, 675767],
          [1481673600000, 683295],
          [1481760000000, 651405],
          [1481846400000, 648570],
          [1482105600000, 648617],
          [1482192000000, 651737],
          [1482278400000, 658950],
          [1482364800000, 606970],
          [1482451200000, 625367],
          [1482796800000, 639189],
          [1482883200000, 634828],
          [1482969600000, 624769],
          [1483056000000, 627449],
          [1483401600000, 664257],
          [1483488000000, 740356],
          [1483574400000, 695703],
          [1483660800000, 737555],
          [1483920000000, 720188],
          [1484006400000, 786615],
          [1484092800000, 813178],
          [1484179200000, 740929],
          [1484265600000, 740628],
          [1484611200000, 731283],
          [1484697600000, 723774],
          [1484784000000, 673280],
          [1484870400000, 663227],
          [1485129600000, 624892],
          [1485216000000, 615080],
          [1485302400000, 639444],
          [1485388800000, 605984],
          [1485475200000, 622142],
          [1485734400000, 607876],
          [1485820800000, 686221],
          [1485907200000, 649931],
          [1485993600000, 679725],
          [1486080000000, 685624],
          [1486339200000, 653612],
          [1486425600000, 642443],
          [1486512000000, 630653],
          [1486598400000, 661768],
          [1486684800000, 710111],
          [1486944000000, 716435],
          [1487030400000, 735751],
          [1487116800000, 738651],
          [1487203200000, 719195],
          [1487289600000, 710001],
          [1487635200000, 712534],
          [1487721600000, 681270],
          [1487808000000, 657727],
          [1487894400000, 637725],
          [1488153600000, 698803],
          [1488240000000, 665321],
          [1488326400000, 734499],
          [1488412800000, 681040],
          [1488499200000, 691252],
          [1488758400000, 675229],
          [1488844800000, 677048],
          [1488931200000, 641664],
          [1489017600000, 598365],
          [1489104000000, 584584],
          [1489363200000, 559099],
          [1489449600000, 572027],
          [1489536000000, 619794],
          [1489622400000, 626393],
          [1489708800000, 623526],
          [1489968000000, 607087],
          [1490054400000, 581008],
          [1490140800000, 567356],
          [1490227200000, 561534],
          [1490313600000, 549270],
          [1490569200000, 558017],
          [1490655600000, 603566],
          [1490742000000, 627624],
          [1490828400000, 651314],
          [1490914800000, 677182],
          [1491174000000, 681367],
          [1491260400000, 673585],
          [1491346800000, 650084],
          [1491433200000, 618477],
          [1491519600000, 622133],
          [1491778800000, 589939],
          [1491865200000, 573660],
          [1491951600000, 569617],
          [1492038000000, 575050],
          [1492383600000, 586886],
          [1492470000000, 542069],
          [1492556400000, 561701],
          [1492642800000, 624243],
          [1492729200000, 623483],
          [1492988400000, 642384],
          [1493074800000, 669968],
          [1493161200000, 634320],
          [1493247600000, 548640],
          [1493334000000, 599221],
          [1493593200000, 554629],
          [1493679600000, 560359],
          [1493766000000, 543984],
          [1493852400000, 425600],
          [1493938800000, 465263],
          [1494198000000, 477222],
          [1494284400000, 436598],
          [1494370800000, 464409],
          [1494457200000, 453930],
          [1494543600000, 443661],
          [1494802800000, 456621],
          [1494889200000, 418581],
          [1494975600000, 416629],
          [1495062000000, 429575],
          [1495148400000, 422132],
          [1495407600000, 411278],
          [1495494000000, 423189],
          [1495580400000, 386507],
          [1495666800000, 353197],
          [1495753200000, 358988],
          [1496098800000, 288009],
          [1496185200000, 256308],
          [1496271600000, 339968],
          [1496358000000, 305128],
          [1496617200000, 305450],
          [1496703600000, 360653],
          [1496790000000, 289541],
          [1496876400000, 324544],
          [1496962800000, 467260],
          [1497222000000, 509942],
          [1497308400000, 522167],
          [1497394800000, 514594],
          [1497481200000, 505496],
          [1497567600000, 512599],
          [1497826800000, 575666],
          [1497913200000, 564943],
          [1497999600000, 567787],
          [1498086000000, 585625],
          [1498172400000, 587477],
          [1498431600000, 635693],
          [1498518000000, 768648],
          [1498604400000, 754485],
          [1498690800000, 827522],
          [1498777200000, 834487],
          [1499036400000, 792867],
          [1499209200000, 880562],
          [1499295600000, 905875],
          [1499382000000, 949969],
          [1499641200000, 945135],
          [1499727600000, 938509],
          [1499814000000, 943871],
          [1499900400000, 958847],
          [1499986800000, 935569],
          [1500246000000, 953475],
          [1500332400000, 928843],
          [1500418800000, 890948],
          [1500505200000, 909736],
          [1500591600000, 914411],
          [1500850800000, 937205],
          [1500937200000, 968933],
          [1501023600000, 929005],
          [1501110000000, 922712],
          [1501196400000, 902217],
          [1501455600000, 873730],
          [1501542000000, 856284],
          [1501628400000, 844692],
          [1501714800000, 838826],
          [1501801200000, 840608],
          [1502060400000, 832135],
          [1502146800000, 803460],
          [1502233200000, 771042],
          [1502319600000, 750240],
          [1502406000000, 767220],
          [1502665200000, 764461],
          [1502751600000, 731523],
          [1502838000000, 694016],
          [1502924400000, 667930],
          [1503010800000, 679115],
          [1503270000000, 641280],
          [1503356400000, 643302],
          [1503442800000, 674354],
          [1503529200000, 688409],
          [1503615600000, 718178],
          [1503874800000, 681179],
          [1503961200000, 672466],
          [1504047600000, 695361],
          [1504134000000, 688242],
          [1504220400000, 688648],
          [1504566000000, 668109],
          [1504652400000, 671091],
          [1504738800000, 615939],
          [1504825200000, 664971],
          [1505084400000, 692167],
          [1505170800000, 712502],
          [1505257200000, 715962],
          [1505343600000, 725778],
          [1505430000000, 732189],
          [1505689200000, 722771],
          [1505775600000, 700349],
          [1505862000000, 668260],
          [1505948400000, 645561],
          [1506034800000, 628882],
          [1506294000000, 599210],
          [1506380400000, 566297],
          [1506466800000, 517378],
          [1506553200000, 519365],
          [1506639600000, 566526],
          [1506898800000, 574204],
          [1506985200000, 603596],
          [1507071600000, 654203],
          [1507158000000, 653576],
          [1507244400000, 627436],
          [1507503600000, 623838],
          [1507590000000, 621409],
          [1507676400000, 591448],
          [1507762800000, 550523],
          [1507849200000, 542910],
          [1508108400000, 537608],
          [1508194800000, 547441],
          [1508281200000, 552986],
          [1508367600000, 538970],
          [1508454000000, 577482],
          [1508713200000, 549827],
          [1508799600000, 517033],
          [1508886000000, 507580],
          [1508972400000, 448456],
          [1509058800000, 528542],
          [1509321600000, 610778],
          [1509408000000, 612997],
          [1509494400000, 631685],
          [1509580800000, 576759],
          [1509667200000, 535293],
          [1509926400000, 467262],
          [1510012800000, 431529],
          [1510099200000, 453082],
          [1510185600000, 482292],
          [1510272000000, 513090],
          [1510531200000, 513819],
          [1510617600000, 534841],
          [1510704000000, 563085],
          [1510790400000, 567883],
          [1510876800000, 558705],
          [1511136000000, 535965],
          [1511222400000, 546491],
          [1511308800000, 580006],
          [1511481600000, 608662],
          [1511740800000, 589370],
          [1511827200000, 558340],
          [1511913600000, 590082],
          [1512000000000, 606423],
          [1512086400000, 615119],
          [1512345600000, 536052],
          [1512432000000, 572939],
          [1512518400000, 587895],
          [1512604800000, 615405],
          [1512691200000, 598052],
          [1512950400000, 615930],
          [1513036800000, 625128],
          [1513123200000, 648702],
          [1513209600000, 622989],
        ],
        lineWidth: 1,
        states: {
          hover: {
            enabled: true,
            lineWidth: 1,
          },
        },
        zones: [
          {
            value: 1544805299403,
            color: '#59cdd5',
          },
          {
            value: 1544805299403,
            color: '#47b74a',
          },
          {
            color: '#2991d1',
          },
        ],
        zoneAxis: 'x',
      },
    ],
  },
  fetchingRecordSets: false,
  alphaDetail: {
    settings: {
      delay: 0,
      visualization: false,
      universe: 'TOP3000',
      truncation: 0.1,
      region: 'USA',
      language: 'EXPRESSION',
      decay: 6,
      neutralization: 'INDUSTRY',
    },
    color: 'YELLOW',
    os: null,
    is: {
      details: {
        records: [
          ['2012', 528845, 20000000, 1496, 1475, 0.4476, 1.52, 0.0995, 0.0213, 0.000441, 0.72],
          ['2013', 322958, 20000000, 1535, 1444, 0.4406, 0.56, 0.0323, 0.0328, 0.000145, 0.15],
          ['2014', 1383767, 20000000, 1501, 1473, 0.4429, 1.53, 0.1384, 0.0395, 0.00062, 0.86],
          ['2015', 1414728, 20000000, 1483, 1476, 0.4459, 1.59, 0.1415, 0.0277, 0.00063, 0.9],
          ['2016', 215172, 20000000, 1501, 1468, 0.4396, 0.22, 0.0215, 0.0763, 0.000097, 0.05],
          ['2017', -514219, 20000000, 1499, 1484, 0.4397, -2.44, -0.1309, 0.029, -0.000591, -1.33],
          ['2012-2017', 3351251, 20000000, 1504, 1468, 0.4426, 0.84, 0.0681, 0.0763, 0.000305, 0.33],
        ],
        schema: {
          properties: [
            {
              type: 'year',
              name: 'year',
              title: 'Year',
            },
            {
              type: 'amount',
              name: 'pnl',
              title: 'PnL',
            },
            {
              type: 'amount',
              name: 'bookSize',
              title: 'Book Size',
            },
            {
              type: 'integer',
              name: 'longCount',
              title: 'Long Count',
            },
            {
              type: 'integer',
              name: 'shortCount',
              title: 'Short Count',
            },
            {
              type: 'percent',
              name: 'turnover',
              title: 'Turnover',
            },
            {
              type: 'decimal',
              name: 'sharpe',
              title: 'Sharpe',
            },
            {
              type: 'percent',
              nam: 'returns',
              title: 'Returns',
            },
            {
              type: 'percent',
              name: 'drawdown',
              title: 'Drawdown',
            },
            {
              type: 'permyriad',
              name: 'margin',
              title: 'Margin',
            },
            {
              type: 'decimal',
              name: 'fitness',
              title: 'Fitness',
            },
          ],
          name: 'is',
          title: 'IS',
        },
      },
      returns: 0.0681,
      drawdown: 0.0763,
      fitness: 0.33,
      checks: [
        {
          name: 'LOW_FITNESS',
          result: 'FAIL',
          limit: 1.3,
          value: 0.33,
        },
        {
          name: 'LOW_SHARPE',
          result: 'FAIL',
          limit: 2,
          value: 0.84,
        },
        {
          name: 'LOW_TURNOVER',
          result: 'PASS',
          limit: 0.01,
          value: 0.4426,
        },
        {
          name: 'HIGH_TURNOVER',
          result: 'PASS',
          limit: 0.7,
          value: 0.4426,
        },
        {
          name: 'CONCENTRATED_WEIGHT',
          limit: 1,
          value: 0.2,
          result: 'PASS',
        },
        {
          name: 'SELF_CORRELATION',
          result: 'PENDING',
        },
        {
          name: 'PROD_CORRELATION',
          result: 'PENDING',
        },
        {
          name: 'D0_SUBMISSION',
          result: 'PASS',
          limit: 5,
          value: 0,
        },
      ],
      margin: 0.000305,
      pnl: 3351251,
      turnover: 0.4426,
      sharpe: 0.84,
    },
    hidden: false,
    name: null,
    code: 'Sum(-returns,3)',
    status: 'UNSUBMITTED',
    competitions: null,
    prod: null,
    grade: 'INFERIOR',
    tags: [],
    dateCreated: '2018-05-24T12:10:25Z',
    id: 'JKOoNPe',
    favorite: false,
    description: null,
    team: null,
    category: null,
    stage: 'IS',
  },
  fetchingData: false,
  recordsSets: null,
  fetchingRecordSetsChart: false,
  chartType: 'pnl',
  summaryIsOpen: true,
  id: 'f476fc10-037b-11e9-b199-9f086102d41d',
};
